import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';

//Menu Bar
export interface Menu {
  headTitle?: string;
  title?: string;
  path?: string;
  icon?: string;
  type?: string;
  badgeClass?: string;
  badgeValue?: string;
  active?: boolean;
  children?: Menu[];
  Menusub?: boolean;
  open?: boolean;
  items?: any;
  isSuperAdminCheck?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {
  currentUserDetail: any;
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  public megaMenu: boolean = false;
  public megaMenuCollapse: boolean = window.innerWidth < 1199 ? true : false;
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerwidth < 991) {
          this.collapseSidebar = false;
          this.megaMenu = false;
        }

        if (evt.target.innerWidth < 1199) {
          this.megaMenuCollapse = true;
        }
      });
    if (window.innerWidth < 991) {
      this.router.events.subscribe(() => {
        this.collapseSidebar = false;
        this.megaMenu = false;
      });
    }
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  ngOnDestroy() {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

  MENUITEMS: Menu[] = [
    // {
    //   headTitle: 'Main',
    // },
    {
      path: '/customer-portal/dashboard',
      title: 'Dashboard',
      type: 'link',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24">
             <path d="M0 0h24v24H0V0z" fill="none"></path>
             <path d="M5 5h6v6H5zm8 0h6v4h-6zm0 8h6v6h-6zM5 15h6v4H5z" opacity=".3"></path>
             <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm10-2h6v6h-6V3zm2 2v2h2V5h-2zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm10-2h6v8h-6v-8zm2 2v4h2v-4h-2z"></path>
             </svg>`,
      // badgeClass: 'success',
      // badgeValue: '1',
      active: false,
      isSuperAdminCheck: true
    },
    {
      path: '/customer-portal/circuit/list',
      title: 'Circuit',
      type: 'link',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24">
      <!-- Background -->
      <path d="M0 0h24v24H0V0z" fill="none"></path>

      <!-- Center Box -->
      <rect x="9" y="9" width="6" height="6" fill="black"></rect>

      <!-- Top Box -->
      <rect x="9" y="2" width="6" height="4" fill="white"></rect>
      <!-- Bottom Box -->
      <rect x="9" y="18" width="6" height="4" fill="white"></rect>
      <!-- Left Box -->
      <rect x="2" y="9" width="4" height="6" fill="white"></rect>
      <!-- Right Box -->
      <rect x="18" y="9" width="4" height="6" fill="white"></rect>

      <!-- Connecting Lines -->
      <!-- Center to Top -->
      <line x1="12" y1="9" x2="12" y2="6" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
      <!-- Center to Bottom -->
      <line x1="12" y1="15" x2="12" y2="18" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
      <!-- Center to Left -->
      <line x1="9" y1="12" x2="6" y2="12" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
      <!-- Center to Right -->
      <line x1="15" y1="12" x2="18" y2="12" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
      </svg>`,
      // badgeClass: 'success',
      // badgeValue: '1',
      active: false,
      isSuperAdminCheck: false

    },
    {
      path: '/customer-portal/ticket/list',
      title: 'Ticket',
      type: 'link',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 32 32">
      <path d="M0 0h32v32H0V0z" fill="none"></path>
      <path 
      d="M8 10h18c1 0 1.8.8 1.8 1.8v3.2a3 3 0 0 0 0 6v3.2c0 1-.8 1.8-1.8 1.8H8c-1 0-1.8-.8-1.8-1.8V21a3 3 0 0 0 0-6v-3.2C6.2 10.8 7 10 8 10z"
      opacity=".3"
      transform="rotate(45 16 16)">
      </path>
      <path 
      d="
      M7 9h20
      a2 2 0 0 1 2 2v3
      a3.5 3.5 0 0 0 0 7v3
      a2 2 0 0 1-2 2H7
      a2 2 0 0 1-2-2v-3
      a3.5 3.5 0 0 0 0-7v-3
      a2 2 0 0 1 2-2zm9 2v18

      M16 13 v1.2
      M16 15 v1.2
      M16 17 v1.2
      M16 19 v1.2
      M16 21 v1.2
      M16 23 v1.2
      "
      stroke="white"
      stroke-width="2"
      fill="none"
      stroke-linecap="round"
      transform="rotate(45 16 16)">
      </path>
      </svg>`,

      // badgeClass: 'success',
      // badgeValue: '1',
      active: false,
      isSuperAdminCheck: false

    },

    {
      path: '/customer-portal/circuit-billing',
      title: 'Pending Bills',
      // title: 'Circuit Billing',
      type: 'link',
      icon:
        `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24">

        <!-- Center (Decision Core) -->
        <rect x="9" y="9" width="6" height="6" rx="1.2" fill="currentColor"/>

        <!-- Top Option -->
        <rect x="9" y="2.5" width="6" height="3.5" rx="0.8" fill="none" stroke="currentColor" stroke-width="1.4"/>

        <!-- Bottom Option -->
        <rect x="9" y="18" width="6" height="3.5" rx="0.8" fill="none" stroke="currentColor" stroke-width="1.4"/>

        <!-- Left Option -->
        <rect x="2.5" y="9" width="3.5" height="6" rx="0.8" fill="none" stroke="currentColor" stroke-width="1.4"/>

        <!-- Right Option -->
        <rect x="18" y="9" width="3.5" height="6" rx="0.8" fill="none" stroke="currentColor" stroke-width="1.4"/>

        <!-- Connecting Lines -->
        <line x1="12" y1="9" x2="12" y2="6.2" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        <line x1="12" y1="15" x2="12" y2="18" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        <line x1="9" y1="12" x2="6.2" y2="12" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        <line x1="15" y1="12" x2="18" y2="12" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        </svg>
      `,

      // badgeClass: 'success',
      // badgeValue: '1',
      active: false,
      isSuperAdminCheck: false
    },
    {
      path: '/customer-portal/received-bill',
      title: 'Received Bills',
      // title: 'Circuit Billing',
      type: 'link',
      icon:
        `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24">

  <!-- Bill document -->
  <rect x="5" y="2.5" width="14" height="19" rx="2"
        fill="none" stroke="currentColor" stroke-width="1.4"/>

  <!-- Bill lines -->
  <line x1="8" y1="7" x2="16" y2="7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  <line x1="8" y1="10" x2="16" y2="10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  <line x1="8" y1="13" x2="13" y2="13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>

  <!-- Received check background -->
  <circle cx="16.5" cy="17" r="3.2" fill="currentColor"/>

  <!-- Check mark -->
  <path d="M15.3 17.1 L16.2 18 L18 15.9"
        fill="none"
        stroke="white"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"/>

</svg>

      `,

      // badgeClass: 'success',
      // badgeValue: '1',
      active: false,
      isSuperAdminCheck: false
    },
    {
      path: '/customer-portal/feasibility/',
      title: 'Feasibility',
      type: 'link',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24">

        <!-- Document -->
        <rect x="4" y="3" width="12" height="16" rx="2"
        fill="none" stroke="currentColor" stroke-width="1.8"/>

        <!-- Check -->
        <path d="M7 11l2 2 4-4"
        fill="none" stroke="currentColor" stroke-width="1.8"
        stroke-linecap="round"/>

       <!-- Magnifier -->
        <circle cx="17" cy="17" r="3"
        fill="none" stroke="currentColor" stroke-width="1.8"/>
        <line x1="19.5" y1="19.5" x2="22" y2="22"
        stroke="currentColor" stroke-width="1.5"
        stroke-linecap="round"/>
        </svg>`,

      // badgeClass: 'success',
      // badgeValue: '1',
      active: false,
      isSuperAdminCheck: false
    },

    {
      path: '/customer-portal/select-customer/',
      title: 'Select Customer',
      type: 'link',
      icon: `<svg xmlns="http://www.w3.org/2000/svg"
      class="side-menu__icon"
      viewBox="0 0 24 24"
      fill="none">

      <!-- User head -->
      <circle cx="10" cy="7" r="3"
              stroke="currentColor" stroke-width="1.6"/>
        
      <!-- User body -->
      <path d="M4.5 18c0-3.2 3-5.5 5.5-5.5s5.5 2.3 5.5 5.5"
            stroke="currentColor" stroke-width="1.6"
            stroke-linecap="round"/>
        
      <!-- Select / Check badge -->
      <circle cx="17.5" cy="16.5" r="3.5"
              stroke="currentColor" stroke-width="1.6"/>
        
      <!-- Check mark -->
      <path d="M15.8 16.5l1.2 1.2 2.2-2.4"
            stroke="black" stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"/>
        
       </svg>`,

      // badgeClass: 'success',
      // badgeValue: '1',
      active: false,
      isSuperAdminCheck: false
    },

    // {
    //   headTitle: 'General',
    // },
    // {
    //   path: '/icon',
    //   title: 'Icons',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.32-1.45-5.12-3.5h1.67c.7 1.19 1.97 2 3.45 2s2.76-.81 3.45-2h1.67c-.8 2.05-2.79 3.5-5.12 3.5z" opacity=".3"></path><circle cx="15.5" cy="9.5" r="1.5"></circle><circle cx="8.5" cy="9.5" r="1.5"></circle><path d="M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></svg>`,
    //   type: 'link',
    //   active: false,
    // },
    // {
    //   title: 'Charts',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19 5H5v14h14V5zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" opacity=".3"></path><path d="M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm2 0h14v14H5V5zm2 5h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"></path></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       title: 'Apex-Charts',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/charts/apexcharts/linecharts',
    //           title: 'Line Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/areacharts',
    //           title: 'Area Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/columncharts',
    //           title: 'Column Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/barcharts',
    //           title: 'Bar Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/mixedcharts',
    //           title: 'Mixed Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/rangeareacharts',
    //           title: 'Range Area Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/timelinecharts',
    //           title: 'Timeline Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/candlestickcharts',
    //           title: 'CandleStick Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/boxplotcharts',
    //           title: 'Boxplot Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/bubblecharts',
    //           title: 'Bubble Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/scattercharts',
    //           title: 'Scatter Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/heatmapcharts',
    //           title: 'Heatmap Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/treemapcharts',
    //           title: 'Treemap Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/piecharts',
    //           title: 'Pie Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/radialbarcharts',
    //           title: 'Radialbar Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/radarcharts',
    //           title: 'Radar Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/charts/apexcharts/polarareacharts',
    //           title: 'Polararea Charts',
    //           type: 'link',
    //           active: false,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/charts/chartjs',
    //       title: 'Chartjs Chart',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/charts/echarts',
    //       title: 'Echart Chart',
    //       type: 'link',
    //       active: false,
    //     },
    //   ],
    // },
    // {
    //   headTitle: 'WEB APPS',
    // },
    // {
    //   title: 'Apps',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M4 12c0 4.08 3.06 7.44 7 7.93V4.07C7.05 4.56 4 7.92 4 12z" opacity=".3"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"></path></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     { path: '/apps/cards', title: 'Cards', type: 'link', active: false },
    //     {
    //       path: '/apps/draggablecards',
    //       title: 'Draggable Cards',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/apps/calendar',
    //       title: 'Calendar',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/apps/contacts',
    //       title: 'Contacts',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/apps/notification',
    //       title: 'Notification',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/apps/widgets',
    //       title: 'Widgets',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/apps/widgetnotification',
    //       title: 'Widget-notification',
    //       type: 'link',
    //       active: false,
    //     },

    //     {
    //       path: '/apps/treeview',
    //       title: 'Treeview',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       title: 'File-manager',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/apps/file-manager/file-manager',
    //           title: 'File-Manager',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/apps/file-manager/file-manager-list',
    //           title: 'File-Manager-List',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/apps/file-manager/file-manager-details',
    //           title: 'File-Manager-Details',
    //           type: 'link',
    //           active: false,
    //         },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   title: 'Elements',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M6.26 9L12 13.47 17.74 9 12 4.53z" opacity=".3"></path><path d="M19.37 12.8l-7.38 5.74-7.37-5.73L3 14.07l9 7 9-7zM12 2L3 9l1.63 1.27L12 16l7.36-5.73L21 9l-9-7zm0 11.47L6.26 9 12 4.53 17.74 9 12 13.47z"></path></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       path: '/elements/alerts',
    //       title: 'Alerts',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/avatar',
    //       title: 'Avatar',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/breadcrumbs',
    //       title: 'Breadcrumbs',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/buttons',
    //       title: 'Buttons',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/button-group',
    //       title: 'Button Group',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/badge',
    //       title: 'Badge',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/dropdown',
    //       title: 'Dropdown',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/listgroup',
    //       title: 'List Group',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/navbar',
    //       title: 'Navbar',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/images-figures',
    //       title: 'Images & figures',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/pagination',
    //       title: 'Pagination',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/popover',
    //       title: 'Popover',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/progress',
    //       title: 'Progress',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/spinners',
    //       title: 'Spinners',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/typography',
    //       title: 'Typography',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/tooltip',
    //       title: 'Tooltip',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/toast',
    //       title: 'Toast',
    //       type: 'link',
    //       active: false,
    //     },
    //     { path: '/elements/tags', title: 'Tags', type: 'link', active: false },
    //     { path: '/elements/tabs', title: 'Tabs', type: 'link', active: false },
    //     {
    //       path: '/elements/scrollspy',
    //       title: 'Scrollspy',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/elements/object-fit',
    //       title: 'Object Fit',
    //       type: 'link',
    //       active: false,
    //     },
    //   ],
    // },
    // {
    //   title: 'Advanced UI',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13zm3-4C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zm4.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z" opacity=".3"></path><path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.21-.64-1.67-.08-.09-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm4 13h-1.77c-1.38 0-2.5 1.12-2.5 2.5 0 .61.22 1.19.63 1.65.06.07.14.19.14.35 0 .28-.22.5-.5.5-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.14 8 7c0 2.21-1.79 4-4 4z"></path><circle cx="6.5" cy="11.5" r="1.5"></circle><circle cx="9.5" cy="7.5" r="1.5"></circle><circle cx="14.5" cy="7.5" r="1.5"></circle><circle cx="17.5" cy="11.5" r="1.5"></circle></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       path: '/advanced/accordion',
    //       title: 'Accordion',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/carousel',
    //       title: 'Carousel',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/modals',
    //       title: 'Modals',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/timeline',
    //       title: 'Timeline',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/sweet-alert',
    //       title: 'Sweet Alert',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/ratings',
    //       title: 'Ratings',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/search',
    //       title: 'Search',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/userlist',
    //       title: 'Userlist',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       title: 'Blog-pages',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/advanced/blog',
    //           title: 'Blog',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/advanced/blog-details',
    //           title: 'Blog-Details',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/advanced/blog-post',
    //           title: 'Blog Post',
    //           type: 'link',
    //           active: false,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/advanced/offcanvas',
    //       title: 'Offcanvas',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/placeholders',
    //       title: 'Placeholders',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/advanced/swiperjs',
    //       title: 'Swiper JS',
    //       type: 'link',
    //       active: false,
    //     },
    //   ],
    // },
    // {
    //   headTitle: 'MULTI LEVELS',
    // },
    // {
    //   title: 'Menu-levels',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M5 9h14V5H5v4zm2-3.5c.83 0 1.5.67 1.5 1.5S7.83 8.5 7 8.5 5.5 7.83 5.5 7 6.17 5.5 7 5.5zM5 19h14v-4H5v4zm2-3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z" opacity=".3"></path><path d="M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-1 6H5v-4h14v4zm-12-.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-1 6H5V5h14v4zM7 8.5c.83 0 1.5-.67 1.5-1.5S7.83 5.5 7 5.5 5.5 6.17 5.5 7 6.17 8.5 7 8.5z"></path></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       title: 'Level-1',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       title: 'Level-2',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {  
    //           title: 'Level-2.1',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           title: 'Level-2.2',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           title: 'Level-2.3',
    //           type: 'sub',
    //           active: false,
    //           children: [
    //             {
    //               title: 'Level-2.3.1',
    //               type: 'link',
    //               active: false,
    //             },
    //             {
    //               title: 'Level-2.3.2',
    //               type: 'link',
    //               active: false,
    //             },
    //             {
    //               title: 'Level-2.3.3',
    //               type: 'link',
    //               active: false,
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   headTitle: 'COMPONENTS',
    // },
    // {
    //   title: 'Forms',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M13 4H6v16h12V9h-5V4zm3 14H8v-2h8v2zm0-6v2H8v-2h8z" opacity=".3"></path><path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"></path></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       title: 'Form Elements',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/form/inputs',
    //           title: 'Inputs',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/checks-radio',
    //           title: 'Checks & Radio',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/input-group',
    //           title: 'Input Group',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/form-select',
    //           title: 'Form Select',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/range-slider',
    //           title: 'Range Slider',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/input-masks',
    //           title: 'Input Masks',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/file-uploads',
    //           title: 'File Uploads',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/datetimepicker',
    //           title: 'Date,Time Picker',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/form/colorpicker',
    //           title: 'Color Pickers',
    //           type: 'link',
    //           active: false,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/form/floating-labels',
    //       title: 'Floating Labels',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/form/form-layouts',
    //       title: 'Form Layouts',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       title: 'Form Editors',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/form/quill-editor',
    //           title: 'Quill Editor',
    //           type: 'link',
    //           active: false,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/form/form-validation',
    //       title: 'Form Validation',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/form/select2',
    //       title: 'Select2',
    //       type: 'link',
    //       active: false,
    //     },
    //   ],
    // },
    // {
    //   title: 'Tables',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M5 5h15v3H5zm12 5h3v9h-3zm-7 0h5v9h-5zm-5 0h3v9H5z" opacity=".3"></path><path d="M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 19H5v-9h3v9zm7 0h-5v-9h5v9zm5 0h-3v-9h3v9zm0-11H5V5h15v3z"></path></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       path: '/tables/basictables',
    //       title: 'Basic Tables',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/tables/grid-tables',
    //       title: 'Grid Js Table',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/tables/datatables',
    //       title: 'Data Tables',
    //       type: 'link',
    //       active: false,
    //     },
    //   ],
    // },
    // {
    //   path: '/landing-page',
    //   title: 'Landing Page',
    //   type: 'link',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4.02C7.6 4.02 4.02 7.6 4.02 12S7.6 19.98 12 19.98s7.98-3.58 7.98-7.98S16.4 4.02 12 4.02zM11.39 19v-5.5H8.25l4.5-8.5v5.5h3L11.39 19z" opacity=".3"></path><path d="M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm0 17.96c-4.4 0-7.98-3.58-7.98-7.98S7.6 4.02 12 4.02 19.98 7.6 19.98 12 16.4 19.98 12 19.98zM12.75 5l-4.5 8.5h3.14V19l4.36-8.5h-3V5z"></path></svg>`,
    //   active: false,
    // },
    // {
    //   title: 'Maps',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M12 4C9.24 4 7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" opacity=".3"></path><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"></path><circle cx="12" cy="9" r="2.5"></circle></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       path: '/maps/leafletmaps',
    //       title: 'Leaflet Maps',
    //       type: 'link',
    //       active: false,
    //     },
    //   ],
    // },
    // {
    //   headTitle: 'PAGES',
    // },
    // {
    //   title: 'Pages',
    //   icon:`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" class="side-menu__icon" viewBox="0 0 24 24"><g></g><g><g></g><g><path d="M21,5c-1.11-0.35-2.33-0.5-3.5-0.5c-1.95,0-4.05,0.4-5.5,1.5c-1.45-1.1-3.55-1.5-5.5-1.5S2.45,4.9,1,6v14.65 c0,0.25,0.25,0.5,0.5,0.5c0.1,0,0.15-0.05,0.25-0.05C3.1,20.45,5.05,20,6.5,20c1.95,0,4.05,0.4,5.5,1.5c1.35-0.85,3.8-1.5,5.5-1.5 c1.65,0,3.35,0.3,4.75,1.05c0.1,0.05,0.15,0.05,0.25,0.05c0.25,0,0.5-0.25,0.5-0.5V6C22.4,5.55,21.75,5.25,21,5z M3,18.5V7 c1.1-0.35,2.3-0.5,3.5-0.5c1.34,0,3.13,0.41,4.5,0.99v11.5C9.63,18.41,7.84,18,6.5,18C5.3,18,4.1,18.15,3,18.5z M21,18.5 c-1.1-0.35-2.3-0.5-3.5-0.5c-1.34,0-3.13,0.41-4.5,0.99V7.49c1.37-0.59,3.16-0.99,4.5-0.99c1.2,0,2.4,0.15,3.5,0.5V18.5z"></path><path d="M11,7.49C9.63,6.91,7.84,6.5,6.5,6.5C5.3,6.5,4.1,6.65,3,7v11.5C4.1,18.15,5.3,18,6.5,18 c1.34,0,3.13,0.41,4.5,0.99V7.49z" opacity=".3"></path></g><g><path d="M17.5,10.5c0.88,0,1.73,0.09,2.5,0.26V9.24C19.21,9.09,18.36,9,17.5,9c-1.28,0-2.46,0.16-3.5,0.47v1.57 C14.99,10.69,16.18,10.5,17.5,10.5z"></path><path d="M17.5,13.16c0.88,0,1.73,0.09,2.5,0.26V11.9c-0.79-0.15-1.64-0.24-2.5-0.24c-1.28,0-2.46,0.16-3.5,0.47v1.57 C14.99,13.36,16.18,13.16,17.5,13.16z"></path><path d="M17.5,15.83c0.88,0,1.73,0.09,2.5,0.26v-1.52c-0.79-0.15-1.64-0.24-2.5-0.24c-1.28,0-2.46,0.16-3.5,0.47v1.57 C14.99,16.02,16.18,15.83,17.5,15.83z"></path></g></g></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       path: '/pages/profile',
    //       title: 'Profile',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/pages/editprofile',
    //       title: 'Edit-Profile',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/pages/aboutus',
    //       title: 'About-Us',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/pages/settings',
    //       title: 'settings',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/pages/invoice',
    //       title: 'Invoice',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/pages/pricing',
    //       title: 'Pricing',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/pages/gallery',
    //       title: 'Gallery',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/pages/todotask',
    //       title: 'Todotask',
    //       type: 'link',
    //       active: false,
    //     },
    //     { path: '/pages/faqs', title: 'Faqs', type: 'link', active: false },
    //     {
    //       path: '/pages/emptypage',
    //       title: 'Empty Page',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       title: 'Mail',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         { path: '/pages/mail', title: 'Mail', type: 'link', active: false },
    //         {
    //           path: '/pages/mail-compose',
    //           title: 'Mail Compose',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/pages/read-mail',
    //           title: 'Mail Read',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/pages/mail-settings',
    //           title: 'mail-settings',
    //           type: 'link',
    //           active: false,
    //         },
    //         { path: '/pages/chat', title: 'Chat', type: 'link', active: false },
    //       ],
    //     },
    //     {
    //       title: 'Ecommerce',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/pages/products',
    //           title: 'Products',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/pages/product-details',
    //           title: 'Product-Details',
    //           type: 'link',
    //           active: false,
    //         },
    //         { path: '/pages/cart', title: 'Cart', type: 'link', active: false },
    //         {
    //           path: '/pages/check-out',
    //           title: 'Check-out',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/pages/wish-list',
    //           title: 'Wish-list',
    //           type: 'link',
    //           active: false,
    //         },
    //       ],
    //     },
    //     {
    //       title: 'Custom Pages',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/custompages/signin',
    //           title: 'Sign in',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/custompages/sign-up',
    //           title: 'Sign up',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/custompages/forgot-password',
    //           title: 'Forgot Password',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/custompages/reset-password',
    //           title: 'Reset Password',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/custompages/lockscreen',
    //           title: 'Lockscreen',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/custompages/under-construction',
    //           title: 'UnderConstruction',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/custompages/error404',
    //           title: '404 Error',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/custompages/error500',
    //           title: '500 Error',
    //           type: 'link',
    //           active: false,
    //         },
    //         {
    //           path: '/pages/error501',
    //           title: '501 Error',
    //           type: 'link',
    //           active: false,
    //         },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   title: 'Utilities',
    //   icon: `<svg xmlns="http://www.w3.org/2000/svg" class="side-menu__icon" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M10.9 19.91c.36.05.72.09 1.1.09 2.18 0 4.16-.88 5.61-2.3L14.89 13l-3.99 6.91zm-1.04-.21l2.71-4.7H4.59c.93 2.28 2.87 4.03 5.27 4.7zM8.54 12L5.7 7.09C4.64 8.45 4 10.15 4 12c0 .69.1 1.36.26 2h5.43l-1.15-2zm9.76 4.91C19.36 15.55 20 13.85 20 12c0-.69-.1-1.36-.26-2h-5.43l3.99 6.91zM13.73 9h5.68c-.93-2.28-2.88-4.04-5.28-4.7L11.42 9h2.31zm-3.46 0l2.83-4.92C12.74 4.03 12.37 4 12 4c-2.18 0-4.16.88-5.6 2.3L9.12 11l1.15-2z" opacity=".3"></path><path d="M12 22c5.52 0 10-4.48 10-10 0-4.75-3.31-8.72-7.75-9.74l-.08-.04-.01.02C13.46 2.09 12.74 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10zm0-2c-.38 0-.74-.04-1.1-.09L14.89 13l2.72 4.7C16.16 19.12 14.18 20 12 20zm8-8c0 1.85-.64 3.55-1.7 4.91l-4-6.91h5.43c.17.64.27 1.31.27 2zm-.59-3h-7.99l2.71-4.7c2.4.66 4.35 2.42 5.28 4.7zM12 4c.37 0 .74.03 1.1.08L10.27 9l-1.15 2L6.4 6.3C7.84 4.88 9.82 4 12 4zm-8 8c0-1.85.64-3.55 1.7-4.91L8.54 12l1.15 2H4.26C4.1 13.36 4 12.69 4 12zm6.27 3h2.3l-2.71 4.7c-2.4-.67-4.35-2.42-5.28-4.7h5.69z"></path></svg>`,
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       path: '/utilities/border',
    //       title: 'Border',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/breakponts',
    //       title: 'Breakponts',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/colors',
    //       title: 'Colors',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/columns',
    //       title: 'Columns',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/flex',
    //       title: 'Flex',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/gutters',
    //       title: 'Gutters',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/helpers',
    //       title: 'Helpers',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/position',
    //       title: 'Position',
    //       type: 'link',
    //       active: false,
    //     },
    //     {
    //       path: '/utilities/additional-content',
    //       title: 'Additional Content',
    //       type: 'link',
    //       active: false,
    //     },
    //   ],
    // },
  ];

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
